import React from 'react';
import DatePicker from 'react-datepicker';
import { Flex, FormControl, FormLabel, Switch, Select } from '@chakra-ui/react';

function StatisticsToolbar({
  startedFrom,
  finishedTo,
  isOnlyActivePartnersShowed,
  env,
  onDatesSelect,
  onTogglePartnersVisibility,
  onSelectEnv,
}) {
  return (
    <Flex justifyContent="flex-start">
      <FormControl display="flex" alignItems="center" mb="5" height="10">
        <FormLabel htmlFor="date-range" mb="0">
          Период:
        </FormLabel>
        <DatePicker
          id="date-range"
          dateFormat="dd.MM.yyy"
          selected={startedFrom}
          startDate={startedFrom}
          endDate={finishedTo}
          selectsRange={true}
          onChange={onDatesSelect}
        />
      </FormControl>

      <FormControl display="flex" alignItems="center" mb={5}>
        <FormLabel htmlFor="env" mb="0">
          Среда
        </FormLabel>
        <Select
          id="env"
          value={env}
          maxW={100}
          onChange={e => onSelectEnv(e.target.value)}
        >
          <option value="all">all</option>
          <option value="test">test</option>
          <option value="prod">prod</option>
        </Select>
      </FormControl>

      <FormControl display="flex" alignItems="center" mb={5}>
        <FormLabel htmlFor="active-merchants" mb="0">
          Показать только активных мерчантов
        </FormLabel>
        <Switch
          id="active-merchants"
          size="lg"
          colorScheme="teal"
          isChecked={isOnlyActivePartnersShowed}
          onChange={onTogglePartnersVisibility}
        />
      </FormControl>
    </Flex>
  );
}

export default React.memo(StatisticsToolbar);
